"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
const React = require("react");
const CurrencyFormat = require("react-currency-format");
const Currency = ({ children, prefix = "$", thousandSeparator = false }) => children ? (React.createElement(CurrencyFormat, { value: children, prefix: prefix, displayType: "text", decimalScale: 2, fixedDecimalScale: true, thousandSeparator: thousandSeparator || null })) : null;
exports.Currency = Currency;
//# sourceMappingURL=index.js.map